module.exports = __webpack_public_path__ + "img/about-1.2a70fdeb.png";